const mappings = [
  {
    route: 'contacts-id-contact-details',
    type: 'client',
    path: 'contact-details',
    filterPaths: ['contact-details', 'personal-details'],
    isRelatedToFactFind: true,
  },
  {
    route: 'contacts-id-bank-accounts',
    type: 'client',
    path: 'bank-accounts',
    isRelatedToFactFind: true,
  },
  {
    route: 'contacts-id-goals',
    type: 'client',
    path: 'goals',
    isRelatedToFactFind: true,
  },
  {
    route: 'contacts-id-relationships',
    type: 'client',
    path: 'relationships',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-dependants',
    type: 'client',
    path: 'dependants',
    filterPaths: ['dependants', 'personal-details'],
    isRelatedToFactFind: true,
  },
  {
    route: 'contacts-id-employment',
    type: 'client',
    path: 'employment',
    filterPaths: ['employment', 'income', 'employment-and-income'],
    isRelatedToFactFind: true,
  },
  {
    route: 'contacts-id-estate',
    type: 'client',
    path: 'estate',
    isRelatedToFactFind: true,
  },
  {
    route: 'contacts-id-expenditure',
    type: 'client',
    path: 'expenditure',
    isRelatedToFactFind: true,
  },
  {
    route: 'contacts-id-health',
    type: 'client',
    path: 'health',
    isRelatedToFactFind: true,
  },
  {
    route: 'contacts-id-income',
    type: 'client',
    path: 'income',
    filterPaths: ['employment', 'income', 'employment-and-income'],
    isRelatedToFactFind: true,
  },
  {
    route: 'contacts-id-state-pension',
    type: 'client',
    path: 'state-pension',
    isRelatedToFactFind: true,
  },
  {
    route: 'contacts-id-staff-members',
    type: 'client',
    path: 'staff-members',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-wealth',
    type: 'client',
    path: 'wealth',
    filterPaths: ['fixed-assets', 'investments', 'debt', 'protection-and-insurance', 'wealth'],
    isRelatedToFactFind: true,
  },
  {
    route: 'contacts-id-wealth-section',
    type: 'client',
    path: 'wealth',
    filterPaths: ['fixed-assets', 'investments', 'debt', 'protection-and-insurance', 'wealth'],
    isRelatedToFactFind: true,
  },
  {
    route: 'contacts-id-emails',
    type: 'client',
    path: 'emails',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-illustrations',
    type: 'client',
    path: 'illustrations',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-cases',
    type: 'client',
    path: 'cases',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-tasks-tasksid',
    type: 'client',
    path: 'tasks',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-documents',
    type: 'client',
    path: 'documents',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-document-builder',
    type: 'client',
    path: 'document-builder',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-forms',
    type: 'client',
    path: 'forms',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-documents',
    type: 'client',
    path: 'documents',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-factfind',
    type: 'client',
    path: 'factfind',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-signatures',
    type: 'client',
    path: 'signatures',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-charges',
    type: 'client',
    path: 'charges',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-charge-splits',
    type: 'client',
    path: 'charge-splits',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-new-business-events',
    type: 'client',
    path: 'new-business-events',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-logged-time',
    type: 'client',
    path: 'logged-time',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-risk',
    type: 'client',
    path: 'risk',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-applications',
    type: 'client',
    path: 'applications',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-audits',
    type: 'client',
    path: 'audits',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-conversations',
    type: 'client',
    path: 'conversations',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-access',
    type: 'client',
    path: 'access',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-be-iq-profiler',
    type: 'client',
    path: 'be-iq-profiler',
    isRelatedToFactFind: true,
  },
  {
    route: 'contacts-id-rq-embed',
    type: 'client',
    path: 'rq-embed',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-seccl-embed',
    type: 'client',
    path: 'seccl-embed',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-reeves-sms-embed',
    type: 'client',
    path: 'reeves-sms-embed',
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-mortgage-searches',
    type: 'client',
    path: 'mortgage-searches',
    filterPaths: ['mortgage-searches', 'personal-details'],
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-mortgage-searches-searchid',
    type: 'client',
    path: 'mortgage-searches',
    filterPaths: ['mortgage-searches', 'personal-details'],
    isRelatedToFactFind: false,
  },
  {
    route: 'contacts-id-shareholders',
    type: 'client',
    path: 'shareholders',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-contact-details',
    type: 'circle',
    path: 'contact-details',
    filterPaths: ['contact-details', 'personal-details'],
    isRelatedToFactFind: true,
  },
  {
    route: 'circle-id-bank-accounts',
    type: 'circle',
    path: 'bank-accounts',
    isRelatedToFactFind: true,
  },
  {
    route: 'circle-id-goals',
    type: 'circle',
    path: 'goals',
    isRelatedToFactFind: true,
  },
  {
    route: 'circle-id-relationships',
    type: 'circle',
    path: 'relationships',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-dependants',
    type: 'circle',
    path: 'dependants',
    filterPaths: ['dependants', 'personal-details'],
    isRelatedToFactFind: true,
  },
  {
    route: 'circle-id-employment',
    type: 'circle',
    path: 'employment',
    filterPaths: ['employment', 'income', 'employment-and-income'],
    isRelatedToFactFind: true,
  },
  {
    route: 'circle-id-estate',
    type: 'circle',
    path: 'estate',
    isRelatedToFactFind: true,
  },
  {
    route: 'circle-id-expenditure',
    type: 'circle',
    path: 'expenditure',
    isRelatedToFactFind: true,
  },
  {
    route: 'circle-id-health',
    type: 'circle',
    path: 'health',
    isRelatedToFactFind: true,
  },
  {
    route: 'circle-id-income',
    type: 'circle',
    path: 'income',
    filterPaths: ['employment', 'income', 'employment-and-income'],
    isRelatedToFactFind: true,
  },
  {
    route: 'circle-id-state-pension',
    type: 'circle',
    path: 'state-pension',
    isRelatedToFactFind: true,
  },
  {
    route: 'circle-id-wealth',
    type: 'circle',
    path: 'wealth',
    filterPaths: ['fixed-assets', 'investments', 'debt', 'protection-and-insurance', 'wealth'],
    isRelatedToFactFind: true,
  },
  {
    route: 'circle-id-wealth-section',
    type: 'circle',
    path: 'wealth',
    filterPaths: ['fixed-assets', 'investments', 'debt', 'protection-and-insurance', 'wealth'],
    isRelatedToFactFind: true,
  },
  {
    route: 'circle-id-emails',
    type: 'circle',
    path: 'emails',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-illustrations',
    type: 'circle',
    path: 'illustrations',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-cases',
    type: 'circle',
    path: 'cases',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-tasks-tasksid',
    type: 'circle',
    path: 'tasks',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-documents',
    type: 'circle',
    path: 'documents',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-document-builder',
    type: 'circle',
    path: 'document-builder',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-forms',
    type: 'circle',
    path: 'forms',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-documents',
    type: 'circle',
    path: 'documents',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-factfind',
    type: 'circle',
    path: 'factfind',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-signatures',
    type: 'circle',
    path: 'signatures',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-charges',
    type: 'circle',
    path: 'charges',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-charge-splits',
    type: 'circle',
    path: 'charge-splits',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-new-business-events',
    type: 'circle',
    path: 'new-business-events',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-logged-time',
    type: 'circle',
    path: 'logged-time',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-risk',
    type: 'circle',
    path: 'risk',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-audits',
    type: 'circle',
    path: 'audits',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-conversations',
    type: 'circle',
    path: 'conversations',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-access',
    type: 'circle',
    path: 'access',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-factfind-access',
    type: 'circle',
    path: 'factfind-access',
    isRelatedToFactFind: false,
  },
  {
    route: 'circle-id-staff-members',
    type: 'circle',
    path: 'staff-members',
    isRelatedToFactFind: false,
  },
];

// currently, each wealth section will return notes for all of wealth sections
const wealthSectionMappings = [
  {
    section: 'assets',
    path: 'fixed-assets',
    filterPaths: ['fixed-assets', 'investments', 'debt', 'protection-and-insurance', 'wealth'],
  },
  {
    section: 'investments-and-plans',
    path: 'investments',
    filterPaths: ['fixed-assets', 'investments', 'debt', 'protection-and-insurance', 'wealth'],
  },
  {
    section: 'liabilities',
    path: 'debt',
    filterPaths: ['fixed-assets', 'investments', 'debt', 'protection-and-insurance', 'wealth'],
  },
  {
    section: 'protection-and-insurance',
    path: 'protection-and-insurance',
    filterPaths: ['fixed-assets', 'investments', 'debt', 'protection-and-insurance', 'wealth'],
  },
];
const wealthSectionPaths = wealthSectionMappings.map((item) => item.path);
const exclusivePortalNotePaths = ['personal-details', 'employment-and-income'];

// determines if we show the notes visibility toggle
const pathsRelatedToFactFindSections = mappings
  .filter((item) => item.isRelatedToFactFind)
  .map((item) => item.path)
  .concat(wealthSectionPaths)
  .concat(exclusivePortalNotePaths);

const getPathForRoute = (route, routeParams) => {
  let item = mappings.find((item) => {
    return item.route === route;
  });

  if (item) {
    // wealth sections don't have a direct route
    if (
      (item.route === 'contacts-id-wealth-section' || item.route === 'circle-id-wealth-section') &&
      routeParams?.section
    ) {
      return wealthSectionMappings.find((item) => item.section === routeParams.section)?.path;
    } else {
      return item?.path;
    }
  }

  return null;
};

const getRouteForPath = (path, type) => {
  const routePrefix = type === 'client' ? 'contacts' : 'circle';

  // handle paths with no direct route on plannrcrm (ie factfind employment and income)
  if (wealthSectionPaths.includes(path)) {
    return {
      name: `${routePrefix}-id-wealth-section`,
      params: { section: path },
    };
  } else if (path === 'personal-details') {
    return `${routePrefix}-id-core`;
  } else if (path === 'employment-and-income') {
    return `${routePrefix}-id-employment`;
  }

  let item = mappings.find((item) => {
    return item.path === path && item.type === type;
  });

  if (item) {
    return item?.route;
  }

  return null;
};

const getFiltersForPath = (path) => {
  if (!path) return null;
  let item = mappings.find((item) => {
    return item.path === path;
  });

  if (wealthSectionPaths.includes(path)) {
    return wealthSectionMappings.find((item) => item.path === path).filterPaths;
  }

  if (item?.filterPaths) {
    return item.filterPaths;
  } else {
    return [path];
  }
};

export { getPathForRoute, getRouteForPath, getFiltersForPath, pathsRelatedToFactFindSections };
